import React, { useEffect } from 'react'
import Constants from '../../config/Constants';
import { Container, Row, Col } from '../ui/GridSystem/GridSystem'
import { TitleH1} from '../ui/Title/Title';
import styled from 'styled-components';
import { Wrapper } from '../ui/Wrapper/Wrapper';
import { Text } from '../ui/Typography/Typography';

const WrapperPage = styled(Wrapper)`
    display: flex;
    align-items: center;
    padding: 20px;
    margin-top: 20px;

    p {
        font-size: 18px!important;
    }
`;


const SectionDescription: React.FC = () => {

    useEffect(() => {
        window.addEventListener("scroll", () => handleParallax())
        return () => {
            window.removeEventListener("scroll", () => {})
        }
    }, [])

    return (
        <WrapperPage margin='60px 0px'>
            <Container>
                <Row>
                    <Col xl={5} lg={5} md={7} sm={12} xs={12}>
                        {renderColumnText()}
                    </Col>
                    <Col offset={{where: ['xl', 'lg'], value: 2}} xl={4} lg={4} md={7} sm={12} xs={12} align='center'>
                        <Text large color='#ccc' className='prllx-yq-txt'medium dangerouslySetInnerHTML={{__html: Constants.DESCRIPTION_TEXT}}/>
                    </Col>
                </Row>
            </Container>
        </WrapperPage>
    );

    function renderColumnText() {
        return (
            <Wrapper width='100%' padding='30px 0px'>
                <TitleH1 white className='prllx-yq' dangerouslySetInnerHTML={{__html: Constants.DESCRIPTION_TITLE}} />
            </Wrapper>
        )
    }

    function handleParallax() {
        if (window.innerWidth < 768) return null;
        const distance = window.scrollY;
        const itemTitle = document.querySelector(".prllx-yq")! as any;
        const itemText = document.querySelector(".prllx-yq-txt")! as any;
        const parallax = (elment: any, speed: number) => {
            elment.style.transform = `translateY(${distance * speed}px)`;
            elment.style.transition = `all 2ms ease-in`;
        }
        setTimeout(() => {
            parallax(itemTitle, .02);
            parallax(itemText, .1);
        }, 2)
    };
};

export default SectionDescription;

